import React, {useRef, useState} from "react";
import {FaCloudUploadAlt} from "react-icons/fa";

function FileInput({text,onChange,className}) {
    const [selectedFile, setSelectedFile] = useState(null);
    const fileInputRef = useRef(null);
    const triggerFileUpload = () => {
        fileInputRef.current.click();
    };
    return (<div>
        <input
            type="file"
            ref={fileInputRef}
            onChange={onChange}
            style={{display: 'none'}}
            accept=".pdf"
        />

        <button className={`btn ${className} d-flex flex-row align-items-center gap-2`}
                onClick={() => {
                    triggerFileUpload()
                }}>
            {text}
            <FaCloudUploadAlt/>
        </button>
        {selectedFile && <p>Selected File: {selectedFile.name}</p>}
    </div>);
}

export default FileInput;